<template>
  <section v-loading="isLoading" class="container">
    <breadcrumb v-if="!isMobile" crumb="pole-rf" />
    <div class="pole__header">
      <el-select
        v-model="filteredStatuses"
        multiple
        placeholder="Фильтр по статусам заявок"
        @change="setFilter"
      >
        <el-option
          v-for="item in statusesList"
          :key="item.code"
          :label="item.title"
          :value="item.code"
        />
      </el-select>
      <el-button
        type="warning"
        size="small"
        round
        @click="$router.push({ name: 'PoleCoefficients' })"
      >
        Редактировать коэффициенты
      </el-button>
    </div>

    <el-row class="bid__title" type="flex" align="middle">
      <el-col
        v-for="field in tableFields"
        :key="field.field"
        :span="field.width"
      >
        {{ field.label }}
      </el-col>
      <el-col :span="3">Статус</el-col>
      <el-col :span="2" />
    </el-row>
    <template v-if="poleBids.length && !isLoading">
      <el-row
        v-for="bid in poleBids"
        :key="bid.id"
        :gutter="24"
        class="bid"
        type="flex"
        align="middle"
      >
        <el-col
          v-for="field in tableFields"
          :key="field.field"
          :span="field.width"
        >
          {{ bid[field.field] }}
        </el-col>
        <el-col :span="3">
          <div :class="['bid__status', bid.status_code]">
            {{ bid.status_title }}
          </div>
        </el-col>
        <el-col :span="2">
          <div class="bid__buttons">
            <el-button
              type="success"
              icon="el-icon-view"
              circle
              @click="showViewModal(bid)"
            />
            <el-button
              type="danger"
              icon="el-icon-edit"
              circle
              @click="showEditModal(bid)"
            />
          </div>
        </el-col>
      </el-row>

      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
    </template>

    <div v-if="!poleBids.length && !isLoading" class="bid__empty">
      Сформированный список заявок пуст!
    </div>

    <el-dialog
      title="Просмотр заявки"
      :visible.sync="isViewOpen"
      :close-on-click-modal="false"
      width="60%"
      @close="isViewOpen = false"
    >
      <bid-view-modal :bid="currentBid" @close="isViewOpen = false" />
    </el-dialog>

    <el-dialog
      v-if="isEditOpen"
      title="Изменение статуса заявки"
      :visible="true"
      :close-on-click-modal="false"
      width="60%"
      @close="isEditOpen = false"
    >
      <bid-edit-modal
        :bid="currentBid"
        :statuses="statusesList"
        @update="updateBid"
        @close="isEditOpen = false"
      />
    </el-dialog>
  </section>
</template>

<script>
import {
  FETCH_POLE_BIDS,
  GET_POLE_BIDS,
  GET_POLE_LOADING,
  GET_POLE_PAGINATION,
  GET_POLE_STATUSES,
  UPDATE_POLE_BID,
} from '@/store/actions/pole'
import { mapActions, mapGetters } from 'vuex'
import { tableFields } from '@/views/PoleRF/data/poleFields'
import BidEditModal from '@/views/PoleRF/components/BidEditModal.vue'
import BidViewModal from '@/views/PoleRF/components/BidViewModal.vue'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb.vue'
import PaginationCustom from '@/components/Tables/PaginationCustom.vue'
export default {
  name: 'PoleRf',
  components: {
    BidEditModal,
    BidViewModal,
    PaginationCustom,
    Breadcrumb,
  },
  data() {
    return {
      currentBid: null,
      isViewOpen: false,
      isEditOpen: false,
      filteredStatuses: [],
      tableFields,
    }
  },
  computed: {
    ...mapGetters({
      poleBids: `pole/${GET_POLE_BIDS}`,
      isLoading: `pole/${GET_POLE_LOADING}`,
      pagination: `pole/${GET_POLE_PAGINATION}`,
      statusesList: `pole/${GET_POLE_STATUSES}`,
    }),
  },
  mounted() {
    this.fetchBids()
  },
  methods: {
    ...mapActions({
      fetchBids: `pole/${FETCH_POLE_BIDS}`,
      saveBid: `pole/${UPDATE_POLE_BID}`,
    }),
    setFilter() {
      const params = this.preparedParams()

      this.fetchBids(params)
    },
    changePage(page) {
      const params = this.preparedParams(page)

      this.fetchBids(params)
    },
    preparedParams(page = 1) {
      return {
        page,
        per_page: this.pagination.perPage,
        status: this.filteredStatuses.length ? this.filteredStatuses : null,
      }
    },
    showViewModal(bid) {
      this.currentBid = bid
      this.isViewOpen = true
    },
    showEditModal(bid) {
      this.currentBid = bid
      this.isEditOpen = true
    },
    updateBid(update) {
      // сохраняем только если были изменения
      if (
        this.currentBid.comment !== update.comment ||
        this.currentBid.status_code !== update.status
      ) {
        const bid = {
          order_id: this.currentBid.id,
          ...update,
        }
        const params = this.preparedParams(this.pagination.currentPage)

        this.saveBid({ bid, params })
      }
      this.isEditOpen = false
    },
  },
}
</script>

<style lang="sass" scoped>
.pole__header
  display: flex
  justify-content: space-between
  align-items: center
.el-select
  width: 470px
  .el-select-dropdown__list
    width: 100%
.bid__title
  margin-top: 40px
  margin-bottom: 20px
  font-weight: bold

.bid__empty
  display: flex
  justify-content: center
  margin: 100px 0
  font-size: 18px
  font-weight: bold
  font-style: italic
  color: #606266

.bid
  min-height: 60px
  padding: 8px 0
  margin-bottom: 16px
  background: #fff
  font-size: 16px

  &__status
    width: fit-content
    padding: 4px 12px
    border-radius: 16px
    color: #fff
    background: #98A9BC
    font-size: 14px
    &.new
      background: #409EFF
    &.in_progress
      background: #67C23A
    &.rejected
      background: #f56c6c

  &__buttons
    display: flex

.el-dialog__wrapper
  display: flex
  ::v-deep .el-dialog
    margin: auto !important
</style>
